<template>
  <div
    class="rt-collapse"
    :class="{'list-panel':listPanel}"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: 'RtCollapse',
  props: {
    accordion: Boolean,
    value: {
      type: [Array, String, Number],
      default: () => []
    },
    listPanel: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeNames: [].concat(this.value)
    };
  },
  provide () {
    return {
      collapse: this
    };
  },
  watch: {
    value (value) {
      this.activeNames = [].concat(this.value);
    }
  },
  methods: {
    handleItemClick (name) {
      if (this.accordion) {
        this.activeNames[0] = this.activeNames[0] === name ? '' : name;
      } else {
        let index = this.activeNames.indexOf(name);
        if (index > -1) {
          this.activeNames.splice(index, 1);
        } else {
          this.activeNames.push(name);
        }
      }
      let value = this.accordion ? this.activeNames[0] : this.activeNames;
      this.$emit('input', value);
      this.$emit('change', value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtCollapse.vue?39ed6df7